import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Malo delo? Poserjem se na vas in vaše demonstracije",
  "description": "",
  "published": "2010-05-18T00:00:00.000Z",
  "redirect_from": ["/blog/malo-delo-poserjem-se-na-vas-in-vase-demonstracije/swizec/1338"],
  "categories": "food for thought, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/49503062604@N01/237431962"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/05/237431962_1444b6dad7_m.jpg",
              "alt": "Riot Control",
              "title": "Riot Control"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/49503062604@N01/237431962"
          }}>{`Steve Crane`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Because this is a local topic the post is in slovene, apologies to both my international readers.`}</p>
    <p>{`Zadnje dni ŠOU že kar malo precej najeda z vso propagando okoli malega dela in kako je to oh in sploh konec sveta, pa da sploh ne omenimo ubogih študentekov kako, da ga bomo nasrkali in ne bomo niti za kavico več imeli.`}</p>
    <p>{`Pa pustimo, da študent sploh ne rabi kavice ampak se na faksu kaj naučit pa zraven en malo štipendije za knjige in kak sendvič.`}</p>
    <p>{`Ok priznam, odkar sem na faksu še ni minil mesec, ko ne bi več časa zapravil za "službo" kot za študijske zadeve - izvzemši seveda izpitna obdobja potem ko sem se pred kakim letom malce spametoval.`}</p>
    <p>{`A vseeno podpiram in pozdravljam malo delo, čeprav sem direktor malega startupa sestavljenega izključno iz študentarije. Malo delo bo super.`}</p>
    <p>{`Zakaj?`}</p>
    <p>{`Ja ker se nič ne bo spremenilo, samo malo se bo povečal obseg kdo vraga lahko dela in tisti ki delajo bodo imeli kako pravico več. Kurba je ko si dva tedna bolan in zato konec mesca ne morš plačat telefona, ali pa greš na malo dopusteka in magično zmanjka vsega denarja.`}</p>
    <p>{`Zveni zelo viktorijansko mar ne? Mogoče celo ameriško.`}</p>
    <p>{`Pfuj in pfej. Amerika in viktorijanstvo sta kul samo za nadbogate, študentarija in reveži se v nobenem primeru nimajo kaj preveč fino. Pri nas pa? Jah študent je car ...`}</p>
    <p>{`... in tako naj ostane.`}</p>
    <p>{`Če znaš dobro delat, kar seveda znaš mar ne, sej te močno srbijo omejitve urnih postavk, to valjda pomeni da zdaj zaslužiš bajno več mar ne? Boš po preračunih z malim delom še vedno lahko zaslužil 6000 eurov na leto. In ja, to ravno pade v tisti minimum, da še ne plačaš davkov.`}</p>
    <p>{`Osebno sem tista leta ko sem zaslužil več kot 6k gagal ko majmun cele dneve in naredil prekleto malo izpitov.`}</p>
    <p>{`Kar se pa tiče demonstracij ...`}</p>
    <p>{`Jaz in ŠOU sva opravila. Današnja automagična prijava na nekakšen SMS klub in to da me zdaj kar nekaj spamajo sta bila pika na i. Ne grem se več.`}</p>
    <p>{`Sem hotel it na demonstracije čist samo tako, za špas, mogoče bi bili pa izgredi in po mojem nisi zares živel dokler nisi bil vsaj enkrat v resnih izgredih - po možnosti v študentskih letih, kasneje ni več fore. Ampak izgredov ne bo, smo preveliki papki.`}</p>
    <p>{`Ah kje so cajti, ki jih opisujejo stari ljubljančani, ko je študentarija zavojevala fakse in ohromila Ljubljano, da so povedali svoje. Zdaj so demonstracije samo še show in komerciala. Pa kak alkohol več se proda na ta račun.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/a3a05ea0-525e-4c09-bf92-94aed194ddb5/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=a3a05ea0-525e-4c09-bf92-94aed194ddb5",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      